import ApiService from "./api";

const Measure = {
    list() {
        return ApiService.get('measures');
    },
};

export default Measure;